import { ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { useQuery } from "@tanstack/vue-query";
import { TokenDto, TokensService } from "@/api/generated";
import { useAccounts } from "@/stores";

const ownedTokens = ref<TokenDto[]>([]);

interface TokensResponse {
  items: TokenDto[]; // Adjust the type of items as needed
}

export function useOwnedTokens() {
  const { activeAccount } = storeToRefs(useAccounts());

  const { data, isFetching } = useQuery({
    queryFn: () =>
      TokensService.listAll({
        ownerAddress: activeAccount.value,
        creatorAddress: activeAccount.value,
        limit: 1000,
      }),
    queryKey: ["TokensService.ownedTokens", activeAccount],
    enabled: !!activeAccount.value,
  });

  watch(data, () => {
    if (data.value) {
      ownedTokens.value = (data.value as TokensResponse).items;
    }
  });

  return { ownedTokens, isFetching };
}
